import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GlobalName } from '../utils/global-name';
import { LocalStorageService } from '../utils/local-stoarge-service';

export const authGuard: CanActivateFn = (_route, _state) => {
  const lsService = inject(LocalStorageService);
  const router = inject(Router);

  if (lsService.get(GlobalName.tokenName) != null) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
